"use strict";

var React = require('react/addons');
var mixins = require('../mixins');
import FieldContainer from 'ofs/react/fields/fieldcontainer';



module.exports = React.createClass({
  mixins: [mixins.BackboneBindingMixin],

  handleChange: function(event) {
    this.props.model.set(this.props.field, event.target.value);
  },

  render: function() {
    const {field, model, error, label} = this.props;

    var options = this.props.choices.map((choice) => {
      var checked = model.get(field) === choice[0];

      return (
        <div className="ofs-PreStayArrival__RadioOptions">
          <label className="ofs-Form__Label ofs-Form__Label--no-bold">
            <input name={this.props.name} className="ofs-Input--radio" type="radio" value={choice[0]} checked={checked ? 'checked' : null} disabled={this.props.disabled} onChange={this.handleChange} />
            <div className="ofs-Input__OptionLabel">{choice[1]}</div>
          </label>
        </div>
      );
    });

    return (
      <FieldContainer label={label}>
        <div>
          {options}
        </div>
        {error ? <p className="ofs-Input__ErrorMessage">{error}</p> : null}
      </FieldContainer>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/fields/radiofield.jsx
 **/